import { VApp } from 'vuetify/lib/components/VApp';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c('router-view'),(_vm.messageShow)?_c('CtrlMessageDialog',{attrs:{"value":_vm.messageShow,"messageID":_vm.messageId},on:{"update:value":function($event){_vm.messageShow=$event},"ok":_vm.handleOKmessage}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }